import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-invalidssocredential',
  templateUrl: './invalidssocredential.component.html',
  styleUrls: ['./invalidssocredential.component.scss']
})
export class InvalidssocredentialComponent implements OnInit {
  items = [
    { title: 'Centralized Audit Management System', desc: ' ' },
    { title: 'Centralized Audit Management System', desc: ' ' }
  ];

  supportEmailID: any = environment.CAMS_SUPPORT_EMAILID;
  constructor() { }

  ngOnInit() {
  }

}
